export const url = {
    internal :{
        trackAdsbRkss : 'http://211.35.58.43:9080/live-flight-gmp', 
        trackAdsbRkpk : 'http://211.35.58.43:9080/live-flight-pus',
        trackAdsbRkpc : 'http://211.35.58.43:9080/live-flight-cju', 
        track : 'http://211.35.58.43:9080/live-flight',    
        buildingServer :'http://175.106.95.10:9002/buildings',
        satMapServer: 'https://xdworld.vworld.kr/2d/Satellite/service/{TileMatrix}/{TileCol}/{TileRow}.jpeg',
        satMapServerLeaflet: 'https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg',
        basicMapServer : 'https://tile.openstreetmap.org/{TileMatrix}/{TileCol}/{TileRow}.png',
        noise :'http://211.35.58.43:9080/live-noise',
        noiseStatistic :'http://211.35.58.43:9080/statistic',
        replay :'http://211.35.58.43:9080/replay/',       
        replayRkss :'http://211.35.58.43:9080/replay/gmp',       
        replayRkpc :'http://211.35.58.43:9080/replay/cju',       
        replayRkpk :'http://211.35.58.43:9080/replay/pus',       
        weather :'http://211.35.58.43:9080/live-weather',
        schedule : 'http://211.35.58.43:9080/live-schedule',
        noiseGis : 'http://211.35.58.43:9080/anps/gis/engine',
        noisePosition : 'http://211.35.58.43:9080/anps/gis/engine?SERVICE=wfs&version=1.1.0&TYPENAME=VIEW_MSRSTN_001&REQUEST=getFeature&SRSNAME=EPSG:4326'
    },
}
